<div *ngIf="appService.showAlert.show"
  class="alert-box zs-border zs-padding-2 zs-margin-0-0-2-0 " [ngClass]="getClasses().bgAndBorderClasses">
  <span class="zs-icon icon-size" [ngClass]="getClasses().iconClasses"></span>
  <p class="zs-margin-0-0-0-1 zs-width-90">
    <span class="zs-font-weight-normal alert-box__message">{{appService.showAlert.message}}</span>
  </p>
  <span class="zs-icon zs-close-icon" (click)="closeAlert()">&#x2715;</span>
</div>

